import React, { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import api from '../api/api';
import { generateRandomToken } from '../utils/stinggenerator';
import ToastMessage from '../utils/mui/righttoptoast';
import { whitecamera } from '../utils/svgs/svgcode';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

const AddnewUser = ({ AddnewModalClose ,fetchUsersData,uploadimg}) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [userId, setUserId] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [status, setStatus] = useState('');
  const [roles, setRoles] = useState('');
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [privileges, setPrivileges] = useState([]);
    const [openToast, setOpenToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastSeverity, setToastSeverity] = useState('success');
  const practiseid = window.getPracticeId();
  const [selectedPrivileges, setSelectedPrivileges] = useState([]);
  const [rolesData,setRolesData]=useState([]);
  const [globalError, setGlobalError] = useState('');
  const [groom,setgroom]=useState(null)
   const [file, setFile] = useState(null);       // stores the selected File object
  const [preview, setPreview] = useState(null);
  const navigate=useNavigate()
    const [emptype,setemptype]=useState('')
    const [hiredate,setHiredate]=useState()
    const dropdowntypes = ["Hourly", "Contractors", "Salaried"];
      const handleDropdownChange = (e) => {
    const value = e.target.value;
  
    setemptype(value);
  };
  const  fetchPriviData = async () => {
    setLoading(true); // Start loading
    try {
      const response = await api.get(`/v1/${practiseid}/privileges/get`);
      if (response.status === 200) {
        setPrivileges(response.data); // Update state with privileges data
      } else {
        setPrivileges([]); // Empty privileges if no data is found
      }
    } catch (error) {
      console.error(error); // Log any errors
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchPriviData(); // Call fetchData when component mounts
  }, []);

  const handleToastClose = () => {
    setOpenToast(false);
  };

  const handlePrivilegeChange = (e) => {
    const { value, checked } = e.target;
    
    // Add or remove the privilege id from the selected list
    if (checked) {
      setSelectedPrivileges((prevSelected) => [...prevSelected, value]);
    } else {
      setSelectedPrivileges((prevSelected) =>
        prevSelected.filter((id) => id !== value)
      );
    }
  };

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  };
  
  const validatePhone = (phone) => {
    const re = /^[0-9]{10}$/; // Validates exactly 10 digits, no spaces or letters
    return re.test(phone);
  };
  

  const fetchRolesData = async () => {
    setLoading(true); // Start loading
    try {
        const response = await api.get(`/v1/${practiseid}/roles/get`);
        if (response.status === 200) {
            setRolesData(response.data); // Update state with privileges data
        } else {
            setRolesData([]); // Empty privileges if no data is found
        }
    } catch (error) {
        console.error(error); 
    } finally {
        setLoading(false); 
    }
};
 
   useEffect(() => {
        fetchRolesData(); // Call fetchData when component mounts
    }, []);

    const handleRoleChange = (e) => {
      const selectedRoleName = e.target.value;
      setRoles(selectedRoleName);  
      const selectedRole = rolesData.find((role) => role.role === selectedRoleName);
      if (selectedRole) {
        setgroom(selectedRole)
        // Filter the privileges based on the selected role ID
        const updatedPrivileges = privileges.filter((privilege) => {
          // Parse the stringified 'role' array into a real array and check if the selectedRole.id is in it
          const rolesArray = JSON.parse(privilege.role); // Convert stringified role array to an actual array
          return rolesArray.includes(selectedRole.id.toString()); // Compare the role ID
        });
        // Set the selected privileges that match the selected role
        const selectedPrivs = updatedPrivileges.map((privilege) => privilege.id.toString());
        setSelectedPrivileges(selectedPrivs);  // Update selected privileges
      }
    };

    const handleReset = async ({email,user}) => {
      if (!email) {
          console.log("No user ID provided!");
        return;
      }
  
      setLoading(true); // Start loading
  
      try {
        const token = generateRandomToken(); // Generate the token
        const baseUrl = window.location.origin; // Dynamically gets the domain where the app is running
        const resetLink = `${baseUrl}/reset/${token}`;
        // Send the request to the forgot password API
        const response = await api.post(`/v1/${practiseid}/auth/forgot-password`, {
          "useremail": email,
          "token": token  
        });
    
        // Email message with enhanced HTML UI
    const message = `
  <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #ddd; border-radius: 8px; background-color: #f9f9f9;">
    <h2 style="color: #555;">Welcome to Our CHIM!</h2>
    <p style="font-size: 14px; line-height: 1.6;">Hi ${user || "there"},</p>
    <p style="font-size: 14px; line-height: 1.6;">
      Your new account has been successfully created. Click the button below to set your password and log in for the first time:
    </p>
    <a href="${resetLink}" 
      style="display: inline-block; padding: 10px 20px; margin: 10px 0; color: #fff; background-color: #28a745; text-decoration: none; border-radius: 5px;">
      Activate Account
    </a>
    <p style="font-size: 14px; line-height: 1.6;">
      If you did not sign up for this account, you can safely ignore this email.
    </p>
    <p style="font-size: 14px; line-height: 1.6; margin-top: 20px;">
      Welcome aboard,<br />
      CHIM
    </p>
  </div>
`;
    if(response.status===200){
      const formData = new FormData();
      formData.append("subject", "Welcome to CHIM");
formData.append("to", email);
formData.append("message", message);
  const resp = await axios.post("/utility/send-email", formData, {
  headers: {
    "Content-Type": "multipart/form-data",
  },
})
    
        if (resp.status === 200) {
      
       
          setLoading(false);
       
        }else if (resp.status === 201) {
          // If status is 201, show an error message
          // setToastMessage(' Unable to send the password reset email. Please try again later.');
          // setToastSeverity('error');
          // setOpenToast(true);
          setLoading(false);
        }else{
          setToastMessage("Something went Wrong while Sending email");
          setToastSeverity('error');
          setOpenToast(true);
        }
    }else{
      setToastMessage("Something went Wrong while Sending email");
      setToastSeverity('error');
      setOpenToast(true);
    
  
    }
        // Send the email with the reset link
       
      } catch (error) {
        setToastMessage('Something went Wrong while Sending email');
        setToastSeverity('error');
        setOpenToast(true);
        console.log(error);
        setLoading(false); // Stop loading state in case of error
      }finally{
          setLoading(false);
      }
    };
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile)); // create preview
    }
  };
    const handleNewUser = async () => {
      if (!groom) {
        return;
      }
      const token = generateRandomToken();
      const payload = {
        "practiceid": practiseid,
        "firstname": firstName,
        "lastname": lastName,
        "email": email,
        "username": userId,
        "phone": phone,
        "permissions": selectedPrivileges,
        "grole": groom.id,
        "status": status,
        "token": token,
        'pwd':'xxxxx',
        role:''
      };
    
      try {
        const response = await api.post(`/v1/${practiseid}/user`, payload);
        if (response.status === 200) {
          fetchUsersData();
          handleReset({email:email,user:firstName+' '+lastName})
          setToastMessage('Create User Successfully!');
          setToastSeverity('success');
          setOpenToast(true);
          await uploadimg({file:file,id:response?.user_id})
              await api.put(`/v1/${practiseid}/user/config`, {
                "rowid":response?.user_id,
                 "emp_type":emptype,
                 "hire_date": dayjs().format("YYYY-MM-DD"),
                 "dash_pins": [
        9,
        8,
        1,
        2
    ]
                     });
          setTimeout(() => {
            setPreview('')
            setFile('')
            AddnewModalClose();


     
            navigate(
          `/onboard-emp?userid=${response?.user_id}&username=${userId}&email=${email}&phone=${phone}`
        )
          }, 1000);
          setTimeout(() => {
            setOpenToast(false);
          }, 2000);
        } else if (response.status === 201) {
          // User already exists
          setToastMessage(response?.message||'Your user ID or email address exists');
          setToastSeverity('error');
          setOpenToast(true);
        
        } else {
          setToastMessage(response?.message||'Please select a unique user ID and Email Address');
          setToastSeverity('error');
          setOpenToast(true);
       
          console.error("Failed to assign room");
        }
      } catch (error) {
        console.error("Error assigning room:", error);
      }
    };
     
  
    const handleSave = () => {
      const newErrors = {};
      setGlobalError(''); // Reset the global error
      if (!email && !phone && !firstName && !lastName && !userId && !roles && selectedPrivileges.length === 0) {
        setGlobalError('Please select required fields');
        return; // Prevent form submission if all fields are empty
      }
      // Validate email
      if (!validateEmail(email)) {
        newErrors.email = 'Please enter a valid email.';
      }
    
      // Validate phone
      if (!validatePhone(phone)) {
        newErrors.phone = 'Please enter a valid phone number.';
      }
    
      // Validate first name
      if (!firstName) {
        newErrors.firstName = 'First name is required.';
      }
    
      // Validate last name
      if (!lastName) {
        newErrors.lastName = 'Last name is required.';
      }
    
      // Validate user ID
      if (!userId) {
        newErrors.userId = 'User ID is required.';
      }
    
      // Validate role
      if (!roles) {
        newErrors.roles = 'Role is required.';
      }
    
      // Validate privileges
      if (selectedPrivileges.length === 0) {
        newErrors.privileges = 'At least one privilege must be selected.';
      }
    
      // Only set the global error if no specific field errors exist
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        // Only show global error if no individual errors are present
        setGlobalError('');
        return; // Prevent form submission if errors exist
      }
    
      // Proceed with the save logic if no errors
      handleNewUser();
    };
    
  

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
      {/* Popup Box */}
      <div className="relative flex flex-col  w-[60%] bg-white pb-2 p-3 rounded-lg shadow-lg max-h-[98vh] overflow-y-auto text-left">
        
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-2">
          <h3 className="font-semibold text-lg">ADD USER</h3>
          <IconButton onClick={AddnewModalClose} className="text-gray-600 hover:text-gray-700">
            <CloseIcon fontSize="meduim" />
          </IconButton>
        </div>
        <div className='flex  items-center justify-center w-full '>
        {globalError && <p className="text-red-500 text-xs mb-2">{globalError}</p>}
        </div>
        {/* Input Fields */}

               <div className='flex w-full justify-center'>
                                <div className="relative w-[70px] h-[70px] rounded-[14px] border-4 border-white bg-gray-200 shadow">
                                        <img
                                       src={preview || "/default-profile.png"}
                                            onError={(e) => e.target.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=='}
                                          alt="Profile"
                                          className="object-cover w-full h-full rounded-[14px]"
                                        />
                                        <input
                                          type="file"
                                          accept="image/*"
                                        onChange={handleFileChange}
                                          className="absolute inset-0 opacity-0 cursor-pointer"
                                        />
                                        <div className="absolute bottom-0 right-0 translate-x-1/2 translate-y-1/2 p-1 rounded-full bg-[#E17954] shadow">
                                          {whitecamera}
                                        </div>
                                      </div>
        
                        </div>
        <div className="grid grid-cols-2 gap-4 mt-3">
          <div>
            <label className="block text-sm font-medium text-gray-700">First Name</label>
            <input
              type="text"
              className=" p-2 border border-gray-300 rounded-md w-full"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
              {errors.firstName && <p className="text-red-500 py-0 my-0 text-xs mt-1">{errors.firstName}</p>}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Last Name</label>
            <input
              type="text"
              className=" p-2 border border-gray-300 rounded-md w-full"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            {errors.lastName && <p className="text-red-500 py-0 my-0 text-xs mt-1">{errors.lastName}</p>}
          
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">User ID</label>
            <input
              type="text"
              className=" p-2 border border-gray-300 rounded-md w-full"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
            />
             {errors.userId && <p className="text-red-500 py-0 my-0 text-xs mt-1">{errors.userId}</p>}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              className={` p-2 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded-md w-full`}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
             {errors.email && <p className="text-red-500 py-0 my-0 text-xs mt-1">{errors.email}</p>}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Phone</label>
            <input
              type="tel"
              className={` p-2 border ${errors.phone ? 'border-red-500' : 'border-gray-300'} rounded-md w-full`}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
              {errors.phone && <p className="text-red-500 py-0 my-0 text-xs mt-1">{errors.phone}</p>}
          </div>

          {/* Status Dropdown */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Status</label>
            <select
              className=" p-2 border border-gray-300 rounded-md w-full"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">Select Status</option>
              <option value="A">Active</option>
              <option value="I">Inactive</option>
            </select>
          </div>

          {/* Roles Dropdown */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Roles</label>
            <select
                className="p-2 border border-gray-300 rounded-md w-full cursor-pointer"
                value={roles}
                onChange={handleRoleChange}
            >
                <option  value="">Select </option>
                {rolesData.map((role) => (
                        <option key={role.id} value={role.role}>
                            {role.role}
                        </option>
                    ))}
              </select>
          </div>
           {/* Employee Type Dropdown */}
      <div className="mb-6">
        <label
          htmlFor="emptype"
          className="block text-sm text-start font-medium text-gray-700 mb-2"
        >
          Select Employee Type
        </label>
        <select
          id="emptype"
          value={emptype}
          onChange={handleDropdownChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#1e90ff]"
        >
          <option value="">-- Select Type --</option>
          {dropdowntypes.map((type, index) => (
            <option key={index} value={type}>
              {type}
            </option>
          ))}
        </select>
      </div>
        </div>
                  <div className="grid grid-cols-4 gap-4 mt-3 ml-2">
                    {/* Iterate through privileges for each page */}
                    {roles !== '' && ['Home Screen', 'Tasks', 'Side Bar', 'RPM', 'QA', 'Payment'].map((page) => (
                        privileges.filter(privilege => privilege.page === page).length > 0 && (
                            <div key={page}>
                                <h2 className="text-lg font-semibold">{page} Privileges</h2>
                                <div className="space-y-2 col-span-1">
                                    {privileges.filter(privilege => privilege.page === page).map((privilege) => (
                                        <div key={privilege.id} className="flex items-center">
                                            <input
                                                type="checkbox"
                                                id={`privilege-${privilege.id}`}
                                                value={privilege.id}
                                                onChange={handlePrivilegeChange}
                                                checked={selectedPrivileges.includes(privilege.id.toString())}
                                                className="mr-2 cursor-pointer"
                                            />
                                            <label htmlFor={`privilege-${privilege.id}`} className="text-sm">
                                                {privilege.privilege}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )
                    ))}
                </div>


        {/* Bottom Buttons */}
        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={AddnewModalClose}
            className="px-4 py-1 bg-gray-100 border-2 text-black rounded-md hover:bg-black hover:text-white"
          >
            Close
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-1 bg-orange-500 text-white rounded-md hover:bg-orange-600"
          >
            Save
          </button>
        </div>
      </div>
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={handleToastClose}
      />
    </div>
  );
};

export default AddnewUser;
